/**
 * @Author: Rikard Lindstrom <code@rikard.io>
 * @Filename: index.js
 */

'use strict';
import SampleEditorView from './SampleEditorView';

// expose on window
window.SampleEditorView = SampleEditorView;
export default SampleEditorView;



// WEBPACK FOOTER //
// ./src/index.js